
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-webrtc-star/~/engine.io-client/index.js
// module id = 644
// module chunks = 0